import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import { black, green } from '@avangard/ui/colors';
import { isRtl } from '@avangard/ui/utils';

type OnlineCountProps = {
    count: number | undefined;
};

const Root = styled.div`
    display: inline-flex;
    position: relative;
    margin-inline-start: 8px;
    color: ${black[50]};
    font-size: 2.4rem;
    font-weight: 600;
`;

const Status = styled.span`
    position: relative;
    right: -2px;
    width: 8px;
    height: 8px;
    background: ${green[100]};
    border-radius: 50%;

    ${isRtl`
        right: initial;
        left: -2px;
    `}
`;

const OnlineCount = (props: OnlineCountProps): React.ReactElement | null => {
    const { count } = props;

    const { t } = useTranslation(['common']);

    const hasOnlineCount = typeof count !== 'undefined';

    if (!hasOnlineCount) {
        return null;
    }

    return (
        <Root>
            ({count})
            <Tooltip arrow placement='top' title={t('common:blocks.status.online') ?? ''}>
                <Status />
            </Tooltip>
        </Root>
    );
};

export { OnlineCount };
